import { Placeholder } from '../Placeholder/Placeholder';

export const ArticleHeaderInfoLoader = () => (
  <div className="mt-20 gap-2 w-full flex flex-col items-center justify-center">
    <Placeholder className="h-10 w-1/2 " />
    <Placeholder className="h-10 w-3/4 " />
  </div>
);
